import { makeStyles } from "@material-ui/core";
import { Palette } from "../../AppConfig";

export const CustomStyles = {
    container: (provided) => ({
        ...provided,
        margin: "2px 2px 0px 8px",
        minWidth: "240px",
    }),
    menu: (provided) => ({
        ...provided,
        border: "1px solid " + Palette.Control.DarkBlueTrans,
    }),
    option: (provided) => ({
        ...provided,
        fontSize: "14px !important",
    }),
    input: (provided) => ({
        ...provided,
        fontSize: "14px !important",
    }),
    // Add more styles as needed
};

export const useStyles = makeStyles({
    root: {
        flex: 1,
        maxWidth: "650px",
    },
    col_header: {
        backgroundColor: Palette.Control.FieldersDarkBlue,
        color: "white",
        fontSize: "12px",
        fontFamily: '"Univers45", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontWeight: "200",
        textAlign: "center",
        padding: "5px 0px",
    },
    row_header: {
        display: "flex",
    },
    row_style: {
        padding: "0px 4px !important",
    },

    row_cell: {
        textAlign: "center",
        display: "flex",
    },

    row_cell_finalPP: {
        paddingTop: "8px",
        font: "400 14px 'canada-type-gibson', sans-serif",
        textAlign: "center",
    },

    admin_drawer_root: {
        top: "0px",
        left: "0px",
        width: "90%",
        height: "-webkit-fill-available",
        display: "flex",
        overflow: "hidden",
        position: "fixed",
        textAlign: "left",
        borderLeft: "3px solid #0000001f",
        borderRadius: "0px",
        flexDirection: "column",
        backdropFilter: "blur(4px)",
        backgroundColor: "#edf0f3e8",
        paddingTop: "103px",
    },
    logo: {
        width: "100%",
        textAlign: "center",
        height: "100px",
        display: "flex",
        alignItems: "center",
        border: "2px dotted #8585b1",
        margin: "10px",
        justifyContent: "center",

        objectFit: "contain",
        "&:hover": {
            backgroundColor: Palette.Control.LightGrey,
        },
    },
    input: {
        display: "none",
    },
    import_logo: {
        position: "absolute",
        left: "0px",
        width: "96%",
        textAlign: "right",
        height: "111px",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-start",
        zIndex: 10,
    },
});
